module.exports = __webpack_public_path__ + "img/avatar-28.f159541f.png";